"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormularioRodape = void 0;
var estiloFormularioRodape = require('./FormularioRodape.module.scss');
var react_1 = __importDefault(require("react"));
var FormularioRodape = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: estiloFormularioRodape.formularioRodape }, children));
};
exports.FormularioRodape = FormularioRodape;
